<template>
  <div :class="{ 'exams-profiles': isExamProfiles }">
    <exams-modal-alert ref="examsModalAlert" />
    <card-form
      :collapsed="!isExamCollapsed"
      class="exam__container exam-item"
    >
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout md-flex="15">
            <md-input-container
              id="patientIdLis"
              :class="{ 'md-input-invalid': errors.has('idExamCode') }"
            >
              <label>Código do Exame</label>
              <md-input
                id="txtNewExamCode"
                v-model="item.details.code"
                name="idExamCode"
                type="text"
                title=""
                disabled
                placeholder="Código do Exame"
              />
            </md-input-container>
          </md-layout>
          <md-layout :md-flex="isExamProfiles ? '30' : '25'">
            <md-input-container
              id="patientName"
              :class="{ 'md-input-invalid': errors.has('examName') }"
            >
              <label>Nome do Exame</label>
              <md-input
                id="txtNewExamName"
                v-model="item.details.name"
                name="examName"
                type="text"
                title=""
                disabled
                placeholder="Nome do Exame"
              />
            </md-input-container>
          </md-layout>
          <md-layout :md-flex="isExamProfiles ? '20' : '15'">
            <md-input-container
              id="examMaterial"
              class="md-advanced-select md-input-placeholder md-has-value"
              :class="{
                'md-input-invalid': errors.has('material'),
              }"
            >
              <label>Material</label>
              <div class="advanced-select__container">
                <model-list-select
                  :id="'cboNewMaterial'"
                  v-model="material"
                  v-validate="'required'"
                  label="label"
                  placeholder="Selecione..."
                  :options="getAvailableMaterials()"
                  name="material"
                >
                  <span slot="no-options">
                    <p class="v-select-no-matching">
                      Desculpe, não foram encontrados materiais para essa pesquisa.
                    </p>
                  </span>
                </model-list-select>
              </div>
              <span class="md-error">Obrigatório</span>
            </md-input-container>
          </md-layout>
          <md-layout v-if="item.details.deadline || item.details.minimumVolume">
            <md-input-container
              v-if="item.details.deadline?.trim()"
              id="deadline"
            >
              <label>Prazo de execução</label>
              <md-input
                id="txtDeadline"
                v-model="item.details.deadline"
                name="deadline"
                type="text"
                title=""
                disabled
                placeholder="Prazo de execução"
              />
            </md-input-container>
            <md-input-container
              v-if="
                item.details.minimumVolume && item.details.minimumVolume.trim() !== ''
              "
              id="minimumVolume"
            >
              <label>Volume</label>
              <md-input
                id="txtMinimumVolume"
                v-model="item.details.minimumVolume"
                name="minimumVolume"
                type="text"
                title=""
                disabled
                placeholder="Volume"
              />
            </md-input-container>
          </md-layout>
          <md-layout
            v-if="!isExamProfiles"
            md-flex="10"
          >
            <md-input-container :class="{ 'md-input-invalid': errors.has('samples') }">
              <label class="dont-wrap">Qtd. Amostras</label>
              <md-input
                id="txtNewSampleQuantity"
                v-model="amount"
                v-validate="'required|min_value:1'"
                v-mask="'###'"
                name="samples"
                show-labels="false"
                maxlength="3"
                data-vv-validate-on="none"
                type="text"
                title=""
                placeholder="Amostras"
                @keydown.enter.native="focusNextField('txtNewAddExamNote')"
              />
              <span
                v-if="errors.firstByRule('samples', 'required')"
                class="md-error"
              >
                Obrigatório
              </span>
              <span
                v-else-if="errors.firstByRule('samples', 'min_value')"
                class="md-error"
              >
                Valor inválido
              </span>
            </md-input-container>
          </md-layout>
          <md-layout>
            <md-input-container
              id="conditioning"
              :class="{ 'md-input-invalid': errors.has('conditioning') }"
            >
              <label>Acondicionamento</label>
              <md-input
                id="txtNewConditioning"
                v-model="conditioning"
                name="conditioning"
                type="text"
                title=""
                disabled
                value="Acondicionamento"
                placeholder="Acondicionamento"
              />
            </md-input-container>
          </md-layout>
        </md-layout>

        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            v-if="!isExamProfiles"
            md-flex="50"
          >
            <md-input-container id="examComments">
              <label for="txtNewAddExamNote">Observação</label>
              <div
                class="orders-new__observation-container"
                @keydown.enter.capture="preventRawEnterFromPropagation"
              >
                <md-textarea
                  id="txtNewAddExamNote"
                  v-model="notes"
                  v-validate=""
                  maxlength="250"
                  type="text"
                  name="exam.comments"
                  title=""
                  placeholder="Observação"
                  @keydown.enter.native="focusNextField('btnNewSubmitExam')"
                />
              </div>
            </md-input-container>
          </md-layout>
          <md-layout
            :md-flex="isExamProfiles ? '80' : '15'"
            class="exam-item__details"
          >
            <div class="exam-item__details-anchor">
              <md-icon
                md-src="/static/images/icon-info.svg"
                class="exam-item__details-icon"
              />
              <a
                id="txtNewExamDetails"
                tabindex="-1"
                :href="'/exames/detalhes?mnemonic=' + item.details.code"
                target="_blank"
                class="exam-item__details-anchor__text"
              >
                Detalhes do Exame
              </a>
            </div>
          </md-layout>
          <md-layout
            v-if="!isExamProfiles"
            md-flex="15"
            class="exam-item__details priority"
          >
            <div v-if="item.details.allowUrgent && allowExamUrgent">
              <md-switch
                v-if="item.details.nobleMaterial === false"
                id="priorityUrgent"
                v-model="urgent"
                name="urgent"
                class="md-primary"
              >
                Urgente
              </md-switch>
            </div>
            <p v-if="item.details.nobleMaterial && !item.details.allowUrgent">
              Este é um material nobre
            </p>
          </md-layout>

          <md-layout
            md-flex="20"
            class="actionbutton-exam"
          >
            <button
              id="btnNewSubmitExam"
              class="btn btn-primary orders-new__patient__submit-button submit-button"
              @click="validateBeforeSubmit"
              @keydown.enter="validateBeforeSubmit"
            >
              OK
            </button>
          </md-layout>
        </md-layout>

        <md-button
          v-if="!disableDeletion"
          class="md-icon-button card-form__delete-button"
          @click="deleteOrderExams(item)"
        >
          <i
            aria-hidden="true"
            class="md-icon card-form__delete-button-icon icon-delete-alt md-theme-default material-icons"
          />
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Excluir exame
          </md-tooltip>
        </md-button>
      </div>

      <md-layout
        slot="collapsed"
        class="collapsed-container card-form--collapsed"
        :md-gutter="24"
        md-flex="100"
        @click="editExam(item)"
      >
        <md-layout class="collapsed__item">
          <div class="md-input-container md-theme-default">
            <h3>Código do Exame</h3>
            <p :title="item.details.code">
              {{ item.details.code }}
            </p>
          </div>
        </md-layout>
        <md-layout
          class="collapsed__item"
          :md-flex="!isExamProfiles ? '25' : '30'"
        >
          <div class="md-input-container md-theme-default">
            <h3>Nome do Exame</h3>
            <p :title="item.details.name">
              {{ item.details.name }}
            </p>
          </div>
        </md-layout>
        <md-layout
          class="collapsed__item"
          :md-flex="!isExamProfiles ? '15' : '20'"
        >
          <div class="md-input-container md-theme-default">
            <h3>Material</h3>
            <p
              class="material"
              :title="materialName"
            >
              {{ materialId }} - {{ materialName }}
            </p>
          </div>
        </md-layout>
        <md-layout class="collapsed__item">
          <div class="md-input-container md-theme-default">
            <h3>Prazo de execução</h3>
            <p :title="item.details.deadline">
              {{ item.details.deadline?.trim() || '-' }}
            </p>
          </div>
        </md-layout>
        <md-layout class="collapsed__item">
          <div class="md-input-container md-theme-default">
            <h3>Volume</h3>
            <p>
              {{ item.details.minimumVolume?.trim() || '-' }}
            </p>
          </div>
        </md-layout>
        <md-layout
          v-if="!isExamProfiles"
          class="collapsed__item"
          md-flex="10"
        >
          <div class="md-input-container md-theme-default">
            <h3 class="dont-wrap">Qtd. Amostras</h3>
            <p>{{ amount }}</p>
          </div>
        </md-layout>
        <md-layout class="collapsed__item">
          <div class="md-input-container md-theme-default">
            <h3>Acondicionamento</h3>
            <p
              class="md20"
              :title="conditioning"
            >
              {{ conditioning }}
            </p>
          </div>
        </md-layout>
        <p
          id="btnNewEditExam"
          class="collapsed__list__item__edit-button"
          :class="{ 'collapsed__list__item__delete-button': disableDeletion }"
          @click="editExam(item)"
        >
          <i
            aria-hidden="true"
            class="md-icon collapsed__list__item__edit-button__icon icon-edit-alt md-theme-default material-icons"
          />
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Editar exame
          </md-tooltip>
        </p>
        <p
          v-if="!disableDeletion"
          id="btnNewDeleteExam"
          class="collapsed__list__item__delete-button"
          @click.prevent="deleteOrderExams(item)"
        >
          <i
            aria-hidden="true"
            class="md-icon card-form__delete-button-icon icon-delete-alt md-theme-default material-icons"
          />
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Excluir exame
          </md-tooltip>
        </p>
      </md-layout>
    </card-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ExamsModalAlert from '../ExamsModalAlert'
import mixin from './examMixin'
import Vue from 'vue'

export default {
  name: 'CommonExam',
  components: {
    'exams-modal-alert': ExamsModalAlert,
  },
  mixins: [mixin],
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters(['allowExamUrgent']),
    material: {
      get: function () {
        if (
          !this.item ||
          !this.item.details ||
          !this.item.details.materials ||
          !this.item.sample.material
        ) {
          return null
        }

        for (let i = 0; i < this.item.details.materials.length; i++) {
          let element = this.item.details.materials[i]
          if (element.id === this.item.sample.material) {
            return element
          }
        }
      },
      set: function (value) {
        if (JSON.stringify(value).length > 2) {
          this.updateExam({
            raw: this.item,
            id: this.item.id,
            code_origin_lis: this.item.code_origin_lis,
            material: !value ? 0 : value.id,
            amount: this.item.sample.amount,
            notes: this.item.notes,
            urgent: this.item.urgent,
          })
        }
      },
    },
    amount: {
      get: function () {
        if (!this.item || !this.item.sample) {
          return 0
        }
        return this.item.sample.amount
      },
      set: function (value) {
        if (!this.item) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: value,
          notes: this.item.notes,
          urgent: this.item.urgent,
        })
      },
    },
    notes: {
      get: function () {
        if (!this.item) {
          return ''
        }
        return this.item.notes
      },
      set: function (value) {
        if (!this.item || !this.item.sample) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: this.item.sample.amount,
          notes: value,
          urgent: this.item.urgent,
        })
      },
    },
    urgent: {
      get: function () {
        if (!this.item) {
          return ''
        }
        return this.item.urgent
      },
      set: function (value) {
        if (!this.item || !this.item.sample) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: this.item.sample.amount,
          notes: this.item.notes,
          urgent: value,
        })
      },
    },
  },
  mounted() {
    this.analyticsSuccessInsertingExam(this.item.details.id)
    let self = this
    Vue.nextTick(function () {
      if (
        !('id_exam_order' in self.item) ||
        self.$route.query.exam !== self.item.id_exam_order.toString()
      ) {
        self.validateBeforeSubmit()
      }
    })
  },
  methods: {
    focusNextField(id) {
      document.getElementById(id).focus()
    },
  },
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/mixins';
@import '../../../../static/stylesheets/components/orders/common-exam';
</style>
